module.exports = __webpack_public_path__ + "img/1.bc03047e.png";